import { Navigate } from "react-router-dom";

import { useGetWhoami } from "@/api/whoami/get-whoami";
import { routePaths } from "@/config/route-paths";
import { usePreviousRoutePath } from "@/hooks/usePreviousRoute";

import { NoTenant } from "./NoTenant";

export const AfterSignIn = () => {
  const { prevRoute } = usePreviousRoutePath();
  const { tenantId, isHost } = useGetWhoami();

  if (prevRoute) {
    return <Navigate to={prevRoute} replace={true} />;
  }

  // ホストは所属テナントを持たない。テナントを選ぶ画面へ送る
  if (isHost) {
    return <Navigate to={routePaths.admin.tenants.getHref()} replace={true} />;
  }

  // ホスト以外で所属が無いのは想定外。テナント一覧は 403 になるため送らない
  if (!tenantId) {
    return <NoTenant />;
  }

  return (
    <Navigate
      to={routePaths.tenants.imageLibrary.getHref(tenantId)}
      replace={true}
    />
  );
};
